import Cleave from 'cleave.js';

export default function (element, data) {
    element.cleave = new Cleave(element, {
        delimiter: '.',
        blocks: [2, 2, 4],
        numericOnly: true,
    });

    element.form.addEventListener("clear", function () {
        setTimeout(function () {
            element.value = "";
        }, 50);
    });

    element.addEventListener("blur", function () {
        const parts = element.value.split(".");

        if (parts.length > 0 && parts[0] != "") {
            parts[0] = ("" + Math.min(Math.max(parseInt(parts[0] || 0) || 0, 1), 31)).padStart(2, "0")
        }

        if (parts.length > 1 && parts[1] != "") {
            parts[1] =  ("" + Math.min(Math.max(parseInt(parts[1] || 0) || 0, 1), 12)).padStart(2, "0")
        }

        if (parts.length > 2 && parts[2] != "") {
            const maxYear = parseInt(new Date().getFullYear()) - 3;
            const minYear = maxYear - 97;
            
            let value = parseInt(parts[2] || 0) || 0;

            if (value < 40) {
                value += 2000;
            }

            if (value < 100) {
                value += 1900;
            }

            parts[2] = ("" + Math.min(Math.max(value, minYear), maxYear)).padStart(4, "0")
        }

        if (parts.length > 2) {
            element.value = parts[0] + "." + parts[1] + "." + parts[2];
        } else if (parts.length > 1) {
            element.value = parts[0] + "." + parts[1];
        } else if (parts.length > 0) {
            element.value = parts[0];
        } else {
            element.value = "";
        }
    });
}

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary